export default "__VITE_ASSET__ILMgwgdM__"